import { createContext, useContext } from 'react';

export type GradeSaveStatus = {
  /** La fila se desmontó antes de que el guardado llegara a salir. */
  onSaveCancel: () => void;
  /** `hasSucceeded` false = falló: se retira «guardando» sin afirmar que se guardó. */
  onSaveEnd: (hasSucceeded: boolean) => void;
  onSaveStart: () => void;
};

function noop(): void {}

// Sin proveedor (listas que no montan la región) guardar sigue funcionando y no anuncia nada.
const GradeSaveStatusContext = createContext<GradeSaveStatus>({ onSaveCancel: noop, onSaveEnd: noop, onSaveStart: noop });

export function useGradeSaveStatus(): GradeSaveStatus {
  return useContext(GradeSaveStatusContext);
}

export default GradeSaveStatusContext;
